import lang from "@/views/modules/Examples/language/en";

export default {
    name: "new-example",
    components: {
    },
    data() {
        return {
            loading: true,
            example: {},
            lang:[],
        }
    },
    mounted() {
        this.getExamples();
        this.lang = lang;
    },
    methods: {
        saveExample() {
            const self = this;
            self.loading = true;
            axios.post('api/modules/examples', self.example).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/examples/' + response.data.example.id + '/edit');
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}